import { Box, Button, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ContentDetail = (props) => {
	const {file}									= useParams()
	const [contentHtml, setContentHtml] 			= useState('');

	useEffect(() => {
		const sanitizedUrl = "/files/"+ file.replace(/[^a-zA-Z0-9.\-]+/g, '')
		
		fetch(sanitizedUrl)
		.then((res) => res.text())
      	.then((html) => setContentHtml(html))
	})

	return (
		<Container>
			<div dangerouslySetInnerHTML={{ __html: contentHtml }} />
			<Button variant="contained" component={Link} to={-1} sx={{ width: 200 }}>Voltar</Button>					
		</Container>
		
	)
}

export default ContentDetail;